module.exports = __webpack_public_path__ + "arrow_up.svg?1793698113381";